import { Location } from 'data/models/location';
import { MapSettings } from 'data/models/MapSettings';

export type Map = ReturnType<typeof Map>;
export function Map(shown : () => boolean, locations : () => Set<Location>, settings : MapSettings) {
    return {
        Shown: shown,
        Locations: locations,
        Settings: settings
    };
}


// WEBPACK FOOTER //
// ./apps/portcall/homepage/map.ts